import { render, staticRenderFns } from "./Ditang.vue?vue&type=template&id=7c205963&scoped=true&"
import script from "./Ditang.vue?vue&type=script&lang=js&"
export * from "./Ditang.vue?vue&type=script&lang=js&"
import style0 from "./Ditang.vue?vue&type=style&index=0&id=7c205963&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c205963",
  null
  
)

export default component.exports